// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 777) return "static/js/recorder.f94c9d593.chunk.js";
	if (chunkId === 12) return "static/js/profiler.f94c9d593.chunk.js";
	if (chunkId === 614) return "static/js/614.f94c9d593.chunk.js";
	if (chunkId === 60) return "static/js/60.f94c9d593.chunk.js";
	if (chunkId === 621) return "static/js/621.f94c9d593.chunk.js";
	if (chunkId === 227) return "static/js/227.f94c9d593.chunk.js";
	if (chunkId === 512) return "static/js/512.f94c9d593.chunk.js";
	if (chunkId === 515) return "static/js/515.f94c9d593.chunk.js";
	if (chunkId === 123) return "static/js/123.f94c9d593.chunk.js";
	if (chunkId === 789) return "static/js/789.f94c9d593.chunk.js";
	if (chunkId === 945) return "static/js/945.f94c9d593.chunk.js";
	if (chunkId === 978) return "static/js/978.f94c9d593.chunk.js";
	if (chunkId === 691) return "static/js/691.f94c9d593.chunk.js";
	if (chunkId === 103) return "static/js/103.f94c9d593.chunk.js";
	if (chunkId === 833) return "static/js/833.f94c9d593.chunk.js";
	if (chunkId === 177) return "static/js/177.f94c9d593.chunk.js";
	if (chunkId === 292) return "static/js/292.f94c9d593.chunk.js";
	if (chunkId === 874) return "static/js/874.f94c9d593.chunk.js";
	if (chunkId === 91) return "static/js/91.f94c9d593.chunk.js";
	if (chunkId === 142) return "static/js/142.f94c9d593.chunk.js";
	if (chunkId === 497) return "static/js/497.f94c9d593.chunk.js";
	if (chunkId === 599) return "static/js/599.f94c9d593.chunk.js";
	if (chunkId === 300) return "static/js/300.f94c9d593.chunk.js";
	if (chunkId === 698) return "static/js/698.f94c9d593.chunk.js";
	// return url for filenames based on template
	return undefined;
};